module.exports = __webpack_public_path__ + "img/Peacecle_TC.0386a645.png";